module.exports = __webpack_public_path__ + "static/media/4ODA2.be43daee.jpg";